import React, { Component, ReactNode } from 'react';

const Loader = React.lazy(() => import('../common/loader'));

export default class IDPResponse extends Component {
  render(): ReactNode {
    return <Loader />;
  }
}